









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PasswordStrength extends Vue {
  @Prop() readonly value!: string;

  public bars = [1, 2, 3, 4, 5];

  get strength (): number {
    let strength = 0;
    if (this.value !== undefined) {
      if (this.value.match(/[a-z]+/)) {
        strength += 1;
      }

      if (this.value.match(/[A-Z]+/)) {
        strength += 1;
      }

      if (this.value.match(/[0-9]+/)) {
        strength += 1;
      }

      if (this.value.match(/[$@#&!]+/)) {
        strength += 1;
      }

      if (this.value.length >= 10) {
        strength += 1;
      }
    }

    return strength;
  }

  get strengthCaption (): string {
    switch (this.strength) {
      case 1:
        return 'Poor';
      case 2:
        return 'Fair';
      case 3:
        return 'Medium';
      case 4:
        return 'Good';
      case 5:
        return 'Strong';
      default:
        return 'None';
    }
  }

  public getStrengthBarLevel (barNumber: number) {
    if (this.strength > 0 && barNumber <= this.strength) {
      return 'password-strength-bar-' + this.strength;
    }

    return '';
  }
}
